import {Button, Col, DatePicker, Input, Row, Select, Space} from "antd";
import {Controller, useFieldArray, useFormContext} from "react-hook-form";
import {LiveEventEventTypeFormFieldsType} from "../../types";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {StyledInputValue} from "../../../../../live-classes/live-classes-form/live-classes-form.style";
import moment from "moment";
import {disabledDate} from "../single-event/event-date";
import {TIMEOPTIONS} from "../../../../../../services/timezones";
import {CallDurationOptions} from "../../../../session-bundle/session/gen-info/session-duration/call-duration-form-field";
import {DeleteFilled, PlusCircleFilled} from "@ant-design/icons";
import {LiveEventEventTypeTopicTypeSeriesEventFormFieldProps} from "./types";

export function LiveEventEventTypeTopicTypeSeriesEventFormField({
  formType,
}: LiveEventEventTypeTopicTypeSeriesEventFormFieldProps) {
  const {control, getValues, formState, clearErrors, watch} =
    useFormContext<LiveEventEventTypeFormFieldsType>();

  const {fields, append, remove} = useFieldArray({
    control,
    name: "classSeries",
  });

  const hasDefaultValue = formType === "edit";
  // const duration = watch("duration");
  // const isCustomSelected = duration === "-1";
  const formValues = watch("classSeries");
  // console.log({formValues});
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        {formState.errors.classSeries?.message && (
          <FormFieldError errorMessage={formState.errors.classSeries.message} />
        )}
        {fields.slice(0, 14).map((item, index) => (
          <div key={item.id}>
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <div>
                    <FormField
                      id={"seriesEventSessionName"}
                      label={"Name of the session"}
                      renderInput={(id) =>
                        hasDefaultValue ? (
                          <StyledInputValue>
                            <p>{getValues(`classSeries.${index}.name`)}</p>
                          </StyledInputValue>
                        ) : (
                          <Controller
                            control={control}
                            name={`classSeries.${index}.name`}
                            render={({
                              field: {onChange, value, ref, onBlur},
                              fieldState: {error},
                            }) => (
                              <Space
                                size={16}
                                direction="vertical"
                                style={{display: "flex"}}
                              >
                                <Input
                                  status={error?.message ? "error" : ""}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  size="large"
                                  value={value === null ? undefined : value}
                                  placeholder="Enter session name"
                                  ref={ref}
                                  id={id}
                                />
                                <FormFieldError errorMessage={error?.message} />
                              </Space>
                            )}
                          />
                        )
                      }
                    />
                  </div>
                </Col>
                <Col span={24} lg={12}>
                  <div>
                    <FormField
                      id={"seriesEventStartDate"}
                      label={"Event date"}
                      renderInput={(id) =>
                        hasDefaultValue ? (
                          <StyledInputValue>
                            <p>{getValues(`classSeries.${index}.startDate`)}</p>
                          </StyledInputValue>
                        ) : (
                          <Controller
                            control={control}
                            name={`classSeries.${index}.startDate`}
                            render={({
                              field: {onChange, value, ref, onBlur},
                              fieldState: {error},
                            }) => (
                              <Space
                                size={16}
                                direction="vertical"
                                style={{display: "flex"}}
                              >
                                <DatePicker
                                  disabledDate={disabledDate}
                                  size="large"
                                  style={{width: "100%"}}
                                  onChange={(date, dateString) => onChange(dateString)}
                                  status={error?.message ? "error" : undefined}
                                  value={!value ? undefined : moment(value)}
                                  onBlur={onBlur}
                                  ref={ref}
                                />
                                <FormFieldError errorMessage={error?.message} />
                              </Space>
                            )}
                          />
                        )
                      }
                    />
                  </div>
                </Col>
                <Col span={24} lg={12}>
                  <div>
                    <FormField
                      id={"seriesEventStartTime"}
                      label={"Event time"}
                      renderInput={(id) =>
                        hasDefaultValue ? (
                          <StyledInputValue>
                            <p>{getValues(`classSeries.${index}.startTime`)}</p>
                          </StyledInputValue>
                        ) : (
                          <Controller
                            control={control}
                            name={`classSeries.${index}.startTime`}
                            render={({
                              field: {onChange, value, ref, onBlur},
                              fieldState: {error},
                            }) => (
                              <Space
                                size={16}
                                direction="vertical"
                                style={{display: "flex"}}
                              >
                                <Select
                                  id={id}
                                  size="large"
                                  status={error?.message ? "error" : undefined}
                                  style={{width: "100%"}}
                                  onChange={onChange}
                                  value={value}
                                  ref={ref}
                                  onBlur={onBlur}
                                  options={TIMEOPTIONS.map((to) => ({
                                    label: to.name,
                                    value: to.value,
                                  }))}
                                  placeholder={"9:00 AM"}
                                />
                                <FormFieldError errorMessage={error?.message} />
                              </Space>
                            )}
                          />
                        )
                      }
                    />
                  </div>
                </Col>
                <Col span={24} lg={12}>
                  <div>
                    <FormField
                      id={"seriesEventDuration"}
                      label={"Event duration"}
                      renderInput={(id) =>
                        hasDefaultValue ? (
                          <StyledInputValue>
                            <p>{getValues(`classSeries.${index}.duration`)}</p>
                          </StyledInputValue>
                        ) : (
                          <Controller
                            control={control}
                            name={`classSeries.${index}.duration`}
                            render={({
                              field: {onChange, value, ref, onBlur},
                              fieldState: {error},
                            }) => (
                              <Space
                                size={16}
                                direction="vertical"
                                style={{display: "flex"}}
                              >
                                <Select
                                  id={id}
                                  size="large"
                                  status={error?.message ? "error" : undefined}
                                  style={{width: "100%"}}
                                  onChange={onChange}
                                  value={value}
                                  ref={ref}
                                  onBlur={onBlur}
                                  options={CallDurationOptions}
                                  placeholder={"Please select a duration"}
                                />
                                <FormFieldError errorMessage={error?.message} />
                              </Space>
                            )}
                          />
                        )
                      }
                    />
                  </div>
                </Col>
                {formValues[index].duration === "-1" && (
                  <Col span={24} sm={12}>
                    <div>
                      <FormField
                        id={"seriesEvenCustomDuration"}
                        label={"Event custom duration (In minutes)"}
                        renderInput={(id) => (
                          <Controller
                            control={control}
                            name={`classSeries.${index}.customDuration`}
                            render={({
                              field: {onChange, value, ref, onBlur},
                              fieldState: {error},
                            }) => (
                              <Space
                                size={16}
                                direction="vertical"
                                style={{display: "flex"}}
                              >
                                <Input
                                  id={id}
                                  status={error?.message ? "error" : ""}
                                  onChange={onChange}
                                  onBlur={onBlur}
                                  size="large"
                                  value={value}
                                  placeholder={"Duration in minutes"}
                                  ref={ref}
                                />
                                <FormFieldError errorMessage={error?.message} />
                              </Space>
                            )}
                          />
                        )}
                      />
                    </div>
                  </Col>
                )}
              </Row>
              <div>
                <Button
                  icon={<DeleteFilled />}
                  onClick={() => remove(index)}
                  size="small"
                  block
                >
                  Remove session
                </Button>
              </div>
            </Space>
          </div>
        ))}
        <div>
          {!hasDefaultValue && fields.length < 14 && (
            <Button
              icon={<PlusCircleFilled />}
              onClick={() => {
                clearErrors("classSeries");
                append({
                  name: "",
                  duration: "15",
                  customDuration: undefined,
                  startDate: moment(new Date()).add(1, "day").format("YYYY-MM-DD"),
                  startTime: "09:00 AM",
                });
              }}
              size="small"
            >
              Add a session
            </Button>
          )}
        </div>
      </Space>
    </div>
  );
}
